import GatepassesContainer from "@features/gatepass/components/GatepassesContainer";
import GatepassRequestContainer from "@features/gatepass/components/GatepassRequestContainer.tsx";
import GatepassType from "@features/gatepass/components/GatepassType";
import GatepassTypeRenderer from "@features/gatepass/components/GatepassTypeRenderer";
import GatepassRequestPreview from "@features/gatepass/components/preview/GatepassRequestPreview.tsx";
import GatepassPage from "@pages/gatepass/GatepassPage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getGatepassRoutes = (): AppRoute => ({
  path: paths.gatepass.index,
  protected: true,
  element: <GatepassPage />,
  requiredPermissions: ["hasGatepassAccess"],
  children: [
    { index: true, redirectTo: paths.gatepass.gatepasses },
    { path: paths.gatepass.gatepasses, element: <GatepassesContainer /> },
    {
      path: `${paths.gatepass.gatepassRequestPreview}/:id`,
      element: <GatepassRequestPreview />,
    },
    { path: paths.gatepass.requestGatepass, element: <GatepassRequestContainer /> },
    {
      path: paths.gatepass.requestGatepass,
      element: <GatepassType />,
      children: [{ path: ":type", element: <GatepassTypeRenderer /> }],
    },
  ],
});
